import { DomainEvent } from '../../../project-management/domain/events/DomainEvent';

/**
 * Design Implementation Flow Events - Following GTD Event Pattern
 */

export class FlowCreated extends DomainEvent {
  constructor(
    public readonly flowId: string,
    public readonly projectId: string,
    public readonly createdBy: string
  ) {
    super(flowId, 'FlowCreated');
  }

  getEventData(): Record<string, any> {
    return {
      flowId: this.flowId,
      projectId: this.projectId,
      createdBy: this.createdBy
    };
  }
}

export class ArtifactAdded extends DomainEvent {
  constructor(
    public readonly flowId: string,
    public readonly artifactId: string,
    public readonly artifactName: string,
    public readonly artifactType: string,
    public readonly addedBy: string
  ) {
    super(flowId, 'ArtifactAdded');
  }

  getEventData(): Record<string, any> {
    return {
      flowId: this.flowId,
      artifactId: this.artifactId,
      artifactName: this.artifactName,
      artifactType: this.artifactType,
      addedBy: this.addedBy
    };
  }
}

export class ConformanceScoreUpdated extends DomainEvent {
  constructor(
    public readonly flowId: string,
    public readonly artifactId: string,
    public readonly previousScore: number,
    public readonly newScore: number,
    public readonly updatedBy: string
  ) {
    super(flowId, 'ConformanceScoreUpdated');
  }

  getEventData(): Record<string, any> {
    return {
      flowId: this.flowId,
      artifactId: this.artifactId,
      previousScore: this.previousScore,
      newScore: this.newScore,
      updatedBy: this.updatedBy
    };
  }
}

export class FlowCompleted extends DomainEvent {
  constructor(
    public readonly flowId: string,
    public readonly projectId: string,
    public readonly totalArtifacts: number,
    public readonly averageConformance: number,
    public readonly completedBy: string
  ) {
    super(flowId, 'FlowCompleted');
  }

  getEventData(): Record<string, any> {
    return {
      flowId: this.flowId,
      projectId: this.projectId,
      totalArtifacts: this.totalArtifacts,
      averageConformance: this.averageConformance,
      completedBy: this.completedBy
    };
  }
}

export class ArtifactStatusChanged extends DomainEvent {
  constructor(
    public readonly flowId: string,
    public readonly artifactId: string,
    public readonly previousStatus: string,
    public readonly newStatus: string,
    public readonly changedBy: string
  ) {
    super(flowId, 'ArtifactStatusChanged');
  }

  getEventData(): Record<string, any> {
    return {
      flowId: this.flowId,
      artifactId: this.artifactId,
      previousStatus: this.previousStatus,
      newStatus: this.newStatus,
      changedBy: this.changedBy
    };
  }
}